import { cn } from '@/lib/utils'
import { cva, VariantProps } from 'class-variance-authority'

const loaderVariants = cva('size-6 animate-[spin_0.5s_linear_infinite] rounded-full border-2', {
  variants: {
    variant: {
      default: 'border-vive-border-focus border-t-transparent',
      process: 'border-gray-300 border-t-gray-500',
    },
    size: {
      default: 'size-6',
      sm: 'size-5',
      xs: 'size-4',
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'default',
  },
})

type LoaderProps = {
  className?: string
  variant?: VariantProps<typeof loaderVariants>['variant']
  size?: VariantProps<typeof loaderVariants>['size']
}

function Loader({ className, variant, size }: LoaderProps) {
  return <div className={cn(loaderVariants({ className, variant, size }))} />
}

export default Loader
